import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox } from '../../../components/Box';
import { selectWorks, selectPermissions } from '../../Api/selectors';
import { Card } from '../../../components/Card';
import { IsOpen } from '../../../components/Icon';
import { DocumentsList } from '../../Documents/components/documentsList';
import cn from 'classnames';
import styles from './CardDocuments.module.css';
import {
  DEP_FINANCE,
  DEP_COMMERCE,
  DEP_WALSTREET,
  DEP_ADMINISTRATION,
  DEP_IT,
  DEP_WORKSHOP,
  DEP_ADMIN,
  DEP_TRANSPORT,
} from '../../../components/Permission/constants';
import { hasPermissions } from '../../../utils/helpers/permissions';


const Container = styled.div`
  font-size: 14px;
width: 100%;
  .cell:first-child {
    text-transform: capitalize;
  }
  .info-card {
    min-width: 260px;
    width: 100%;
  }
`;

const STATE = {
  isOpen: true,
};
/* eslint-disable react/prefer-stateless-function */
class VehicleDocumentsCardComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {

  }

  get vehicle() {
    return this.props.vehicle;
  }

  get isCreditor() {
    return this.vehicle?.creditor_company;
  }

  get isDebitor() {
    return this.vehicle?.isDebitor && this.vehicle.invoice_outgoing_company_id;
  }

  render() {
    const vehicle = this.props.vehicle;

    return (
      <Container>
        <Card className={cn('vehicle-info-card info-card data', styles.card)}>
          <HBox>
            <h2 className="card-title mb-2 text-muted">{this.lbl('vehicle.info.documents.title')}</h2>
            <div onClick={() => this.setState({ isOpen: !this.state.isOpen })}>
                  <IsOpen />
                </div>
            {/* {!this.props.isEditPage
              ? window.innerWidth <= 768 && (
                  <div onClick={() => this.setState({ isOpen: !this.state.isOpen })}>
                    <IsOpen />
                  </div>
                )
              : null} */}
          </HBox>

          {(this.state.isOpen) && (
            <DocumentsList
              entityId={vehicle.id}
              entityType="vehicle"
              fromKanban={this.props.fromKanban}
              items={vehicle.documents}
              isCreditor={this.isCreditor}
              isDebitor={this.isDebitor}
              vehicle={this.props.vehicle}
            ></DocumentsList>
          )}
        </Card>
      </Container>
    );
  }
}

VehicleDocumentsCardComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleDocumentsCard = compose(withConnect, withRouter)(VehicleDocumentsCardComp);
